module.exports = __webpack_public_path__ + "static/media/lambo-backgroundMOBILE.8f8105a6.jpg";